import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../common/selectCustom'
import { changeFilter, selectFilter } from '../store/slice'
export const DegreeSelect = () => {
  const dispatch = useDispatch()
  const degree = useSelector(selectFilter('degree'))

  const data = [
    {
      label: 'connectMap.interconnectionMap.DEGREE_1',
      value: 1,
      isI18n: true,
    },
    {
      label: 'connectMap.interconnectionMap.DEGREE_2',
      value: 2,
      isI18n: true,
    },
    {
      label: 'connectMap.interconnectionMap.DEGREE_3',
      value: 3,
      isI18n: true,
    },
  ]
  const selectCategory = (value) => {
    dispatch(
      changeFilter({
        degree: value.value,
      }),
    )
  }

  return (
    <div
      className="positionAbsolute"
      style={{
        top: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99,
      }}
    >
      <SelectCustom
        activeItem={data?.find((item) => item?.value === degree)}
        data={data}
        style={{
          maxWidth: 120,
          height: 28,
          backgroundColor: '#FFFFFF',
        }}
        isI18n
        chooseItem={selectCategory}
      />
    </div>
  )
}
